import { Injectable } from "@angular/core";
import { IAbstractPresenter } from "@core/interfaces";
import { ITabsComponent, ITabsPresenter, ITabItem } from "./interfaces";
import { DisplayMode, DisplayModeValues } from './enums';

@Injectable({ providedIn: 'root' })
export class TabsPresenter 
    extends IAbstractPresenter<ITabsComponent>
    implements ITabsPresenter
{
	tabs: ITabItem[] = [];
	selectedTab: string | null = null;
	displayMode: DisplayModeValues = DisplayMode.ONLYTEXT;
	scrollable: boolean = true;

	constructor () {
		super();
	}

	dispatchActions(): void {}

	suscribeObservers(): void {}

	onTabChanged(value: string): void {
		this.view.emitChange(value);
	}
}